import React, {useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import PopupForm from './PopupForm';
import getObjectValue from 'libs/getObjectValue';
import {POSITION_VALUE as demandPositionValue} from 'constants/PositionItems'
import {POSITION_VALUE as pgPositionValue} from "constants/PurchasingGroupPositionItems";
import CommissionService from 'services/CommissionService';
import isResponseValid from "libs/isResponseValid";
import reduxStore from "redux/store";
import {setResource} from "../../../redux/actions";

const style = theme => ({
	root: {

	},
	actions: {
		marginTop: theme.spacing(2)
	}
})

function AddCandidate({
	classes,
	onClose = () => { },
	formikProps
}) {

	const elementsCount = getObjectValue("users", formikProps.values, []).length;
	const [working, setWorking] = useState(false);
	const [error, setError] = useState(null);

	const handleAdd = (values) => {
		setError(null);
		setWorking(true);
		CommissionService.addExternal(values).then((res) => {
			if(isResponseValid(res, setError)) {
				const {resources} = reduxStore.getState();
				const pgMode = !!resources.purchasingGroupHeader;

				formikProps.setFieldValue(`users.${elementsCount}`, {
					...res,
					role: pgMode ? pgPositionValue.OTHER : demandPositionValue.MEMBER,
				})

				if(!pgMode) {
					const newList = [...resources[CommissionService.COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID], res];
					reduxStore.dispatch(setResource(CommissionService.COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID, newList))
				}

				onClose();
			} else {
				setWorking(false);
			}
		})
	}

	return (
		<Dialog
			title={Tr('new_external_candidate')}
			open={true}
			maxWidth='xs'
			onClose={onClose}
		>
			<PopupForm
				onSubmit={handleAdd}
				onClose={onClose}
				userList={formikProps.values["users"]}
				working={working}
				error={error}
			/>
		</Dialog>
	)
}

AddCandidate.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(AddCandidate);